import { useState, useEffect } from 'react';
import { SearchResponse } from '../contexts/SearchContext';

const useSearch = (word: string): [SearchResponse, boolean, any] => {
  const [response, setResponse] = useState<SearchResponse>({} as SearchResponse);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const result = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`);
        const resultJson = await result.json();
        setResponse(resultJson[0]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (error: any) {
        setError(error.message);
      }
      setLoading(false);
    };

    if (word) {
      fetchData();
    }
  }, [word]);

  return [response, loading, error];
};

export default useSearch;